import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/crawler-thumb.svg'


const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`grid grid-cols-12 items-center`)
}
const _hoisted_2 = { class: "col-span-3 relative" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "thumb-video",
  class: "w-full h-32 object-cover object-center transition-all"
}
const _hoisted_4 = {
  key: 0,
  class: "col-span-12"
}
const _hoisted_5 = {
  key: 1,
  class: "col-span-9 flex flex-col gap-3 p-5"
}
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "flex gap-3 items-center" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex items-center gap-1 font-bold p-3 text-black" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "-", -1)
const _hoisted_14 = { class: "w-full py-5 text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoComponent = _resolveComponent("VideoComponent")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardData, (item, index) => {
    return (_openBlock(), _createElementBlock("section", {
      key: index,
      class: "my-5"
    }, [
      _createElementVNode("div", {
        ref_for: true,
        ref: "cards",
        class: _normalizeClass(`bg-white rounded-t-md shadow-sm overflow-hidden`)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.grow[index]?.value === false)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          (_ctx.grow[index]?.value === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_VideoComponent, {
                  data: { url: item.url },
                  idVideo: item.uuid,
                  startTime: _ctx.time,
                  attention: false,
                  ref_for: true,
                  ref: "videoComponent"
                }, null, 8, ["data", "idVideo", "startTime"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.grow[index]?.value === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("h6", _hoisted_6, _toDisplayString(item.nameVideo), 1),
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t("crawler.words.course")), 1),
                  _createTextVNode(" " + _toDisplayString(item.nameCourse), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("crawler.words.chapter")), 1),
                    _createTextVNode(" " + _toDisplayString(item.nameChapter), 1)
                  ]),
                  _createElementVNode("p", _hoisted_10, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("crawler.words.duration")), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.generics.getDurationTime(item.duration)), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 512),
      _createVNode(_component_Accordion, {
        class: "accordion-material-custom",
        lazy: true,
        onTabOpen: ($event: any) => (_ctx.open($event, index)),
        onTabClose: ($event: any) => (_ctx.close($event, index))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionTab, {
            header: _ctx.$t('crawler.indexWords')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.transcripts, (info, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", {
                    class: "border-b flex items-center w-full gap-3 hover:bg-h-secondary-50 transition-all cursor-pointer",
                    onClick: _withModifiers(($event: any) => (_ctx.onClickDuration(info.startTime, index)), ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.duration(info.startTime)), 1),
                      _hoisted_13,
                      _createElementVNode("p", null, _toDisplayString(_ctx.duration(info.endTime)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", null, _toDisplayString(info.transcript), 1)
                    ])
                  ], 8, _hoisted_11)
                ]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["header"])
        ]),
        _: 2
      }, 1032, ["onTabOpen", "onTabClose"])
    ]))
  }), 128))
}